<ng-container>
    <div class="alert alert-danger" role="alert">
        You can not access this panel.
      </div>
</ng-container>